<template>
    <div class="sibling-discount-container">
      <el-card shadow="hover">
        <template #header>
          <div class="card-header">
            <h2>إدارة سياسة خصم الإخوة</h2>
          </div>
        </template>
  
        <el-alert
          title="ما هي هذه الواجهة؟"
          type="info"
          description="هذه الواجهة تسمح لك بتحديد سياسة الخصم التلقائي للإخوة لكل سنة دراسية. عند إصدار فاتورة لولي أمر لديه أكثر من طالب، سيقوم النظام باقتراح الخصم المناسب بناءً على القواعد التي تضعها هنا."
          :closable="false"
          show-icon
          style="margin-bottom: 20px;"
        />
  
        <el-form label-position="top">
          <el-form-item label="1. اختر السنة الدراسية لعرض أو تعديل سياسة الخصم">
            <el-select v-model="selectedStudyYear" placeholder="اختر السنة الدراسية" @change="fetchDiscounts" clearable style="width: 100%;">
              <el-option v-for="year in studyYears" :key="year.id" :label="year.name" :value="year.id" />
            </el-select>
          </el-form-item>
        </el-form>
        
        <el-divider v-if="selectedStudyYear" />
  
        <div v-if="selectedStudyYear">
          <div v-for="(discount, index) in discounts" :key="index" class="discount-row">
              <el-form-item :label="`خصم لـ ${discount.number_of_siblings} إخوة`">
                   <el-input-number v-model="discount.discount_percentage" :min="0" :max="100" :step="1" placeholder="النسبة %" />
              </el-form-item>
               <el-button type="danger" circle @click="removeDiscountRule(index)"><el-icon><Delete /></el-icon></el-button>
          </div>
          
          <el-button @click="addDiscountRule" style="margin-top: 10px;"><el-icon><Plus /></el-icon> إضافة قاعدة خصم جديدة</el-button>
          
          <div style="text-align: center; margin-top: 30px;">
            <el-button type="primary" @click="saveChanges" :loading="isSaving" size="large">
              <el-icon><Finished /></el-icon> حفظ سياسة الخصم
            </el-button>
          </div>
        </div>
         <div v-else>
          <el-empty description="الرجاء اختيار السنة الدراسية." />
        </div>
  
      </el-card>
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  import { ElMessage } from 'element-plus';
  import { Plus, Delete, Finished } from '@element-plus/icons-vue';
  
  export default {
    name: 'SiblingDiscountManagement',
    components: { Plus, Delete, Finished },
    data() {
      return {
        api: null,
        loading: false,
        isSaving: false,
        studyYears: [],
        selectedStudyYear: null,
        discounts: [],
      };
    },
    created() {
      this.api = axios.create({ baseURL: process.env.VUE_APP_API_BASE_URL || 'https://cale.caledonian.ly/api' });
      this.api.interceptors.request.use((config) => {
        const token = localStorage.getItem('access_token');
        if (token) config.headers['Authorization'] = `Bearer ${token}`;
        return config;
      });
      this.fetchStudyYears();
    },
    methods: {
      async fetchStudyYears() {
          try {
            const response = await this.api.get('/study-years');
            this.studyYears = response.data.data || response.data;
          } catch (error) {
            ElMessage.error('فشل في جلب الأعوام الدراسية.');
          }
      },
      async fetchDiscounts() {
        if (!this.selectedStudyYear) {
          this.discounts = [];
          return;
        }
        this.loading = true;
        try {
          const response = await this.api.get('/sibling-discounts', { params: { study_year_id: this.selectedStudyYear } });
          this.discounts = response.data;
        } catch (error) {
          ElMessage.error('فشل في جلب سياسة الخصم.');
        } finally {
          this.loading = false;
        }
      },
      addDiscountRule() {
          const lastRule = this.discounts[this.discounts.length - 1];
          const newNumberOfSiblings = lastRule ? lastRule.number_of_siblings + 1 : 2;
  
          // Check if a rule for this number of siblings already exists
          if (this.discounts.some(d => d.number_of_siblings === newNumberOfSiblings)) {
              ElMessage.warning(`قاعدة لـ ${newNumberOfSiblings} إخوة موجودة بالفعل.`);
              return;
          }
  
          this.discounts.push({
              number_of_siblings: newNumberOfSiblings,
              discount_percentage: 0,
              study_year_id: this.selectedStudyYear,
          });
      },
      removeDiscountRule(index) {
          this.discounts.splice(index, 1);
      },
      async saveChanges() {
        if (!this.selectedStudyYear) {
          ElMessage.warning('الرجاء اختيار سنة دراسية أولاً.');
          return;
        }
        this.isSaving = true;
        try {
          await this.api.post('/sibling-discounts', {
            study_year_id: this.selectedStudyYear,
            discounts: this.discounts,
          });
          ElMessage.success('تم حفظ سياسة الخصم بنجاح!');
          this.fetchDiscounts();
        } catch (error) {
          ElMessage.error(error.response?.data?.message || 'فشلت عملية الحفظ.');
        } finally {
          this.isSaving = false;
        }
      },
    },
  };
  </script>
  
  <style scoped>
  .sibling-discount-container { padding: 20px; }
  .card-header { display: flex; justify-content: space-between; align-items: center; }
  .discount-row {
      display: flex;
      align-items: center;
      gap: 15px;
      margin-bottom: 15px;
      padding-bottom: 15px;
      border-bottom: 1px solid #f0f0f0;
  }
  .discount-row:last-child {
      border-bottom: none;
  }
  </style>
  